import { Mesh } from './Mesh';
import { Texture } from '../texturing/Texture';
import { Vec2 } from '../math/vec2';
import { Transformable } from './Transformable';
export class Sprite extends Transformable {
    constructor(renderer) {
        super();
        this.scale = 1;
        this.border = 0;
        this.useLinear = 0;
        this.renderer = renderer;
        this.shader = renderer.getShader();
        this.mesh = Mesh.create(renderer, this);
    }
    loadTexture(url) {
        return new Promise((resolve) => {
            this.texture = new Texture(this.renderer);
            this.texture.load(url).then(() => {
                this.transform.scale = new Vec2(this.texture.width, this.texture.height);
                resolve();
            });
        });
    }
    setTexture(texture) {
        this.texture = texture;
        this.transform.scale = new Vec2(this.texture.width, this.texture.height);
    }
    setScale(scale) {
        this.scale = scale;
    }
    dispose() {
        this.mesh.dispose();
        this.texture.dispose();
    }
    draw(camera) {
        if (this.texture) {
            this.mesh.draw(this.shader, this.texture, camera);
        }
    }
}
//# sourceMappingURL=Sprite.js.map